import { Group, Text } from '@mantine/core'

import CoinIcon from '@/components/CoinIcon'
import { I18nLink } from '@/i18n/navigation'
import type { CoinOverall } from '@/types/coin'

interface Props {
  coin: Partial<Pick<CoinOverall, 'id' | 'token_id' | 'name' | 'symbol' | 'slug'>>
  isOGPrice?: boolean
}

export default function CoinColumn({ coin, isOGPrice }: Props) {
  const content = (
    <Group gap="8px" wrap="nowrap">
      <CoinIcon coin={coin} />
      <Group gap="8px">
        <Text
          variant="body"
          c="var(--content-primary)"
          truncate
          maw={{ base: '100px', midScale: '250px' }}
          title={coin.name}
        >
          {coin.name}
        </Text>
        <Text
          variant="body"
          c={isOGPrice ? 'var(--content-secondary)' : 'var(--content-tertiary)'}
          truncate
          maw="100px"
          visibleFrom="midScale"
          title={coin.symbol}
        >
          {coin.symbol}
        </Text>
      </Group>
    </Group>
  )
  if (isOGPrice) {
    return content
  }
  return (
    // The I18nLink is mainly use for SEO
    // For OGPrice we didn't need it
    <I18nLink prefetch={false} href={`/${coin.slug}`}>
      {content}
    </I18nLink>
  )
}
